import Vue from "vue";
import App from "./App.vue";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

import Default from "./layouts/Default.vue";
import SignIn from "./layouts/SignIn.vue";

Vue.component("Default-layout", Default);
Vue.component("SignIn-layout", SignIn);

const requireComponent = require.context(
  "./components",
  false,
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, "$1"))
  );

  Vue.component(componentName, componentConfig.default || componentConfig);
});

new Vue({
  router,
  store,
  vuetify,
  created() {
    const userString = localStorage.getItem("user");
    if (userString !== null) {
      this.$store.dispatch("user/setUser", JSON.parse(userString));
    }

    const columnVisibilityString = localStorage.getItem("columnVisibility");
    if (columnVisibilityString !== null) {
      this.$store.dispatch(
        "columnVisibility/setActiveColumns",
        JSON.parse(columnVisibilityString)
      );
    }

    const filtersString = sessionStorage.getItem("filters");
    if (filtersString !== null) {
      this.$store.dispatch("filters/setFilters", JSON.parse(filtersString));
    }

    const rulesString = sessionStorage.getItem("rules");
    if (rulesString !== null) {
      this.$store.dispatch("rules/setPrevRules", JSON.parse(rulesString));
    }
  },
  render: h => h(App)
}).$mount("#app");
